import Renderer from './Renderer';
import RGBA from '../colors/RGBA';

// let logged = false;

export default class FrameBuffer {
	binders: Array<WebGLFramebuffer>;
	x: number;
	y: number;
	width: number;
	height: number;
	clearColor: RGBA;

	constructor (x: number, y: number, width: number, height: number) {
		this.binders = [];
		this.clearColor = new RGBA(0.0, 0.0, 0.0, 0.0);

		this.x = 0;
		this.y = 0;
		this.width = 0;
		this.height = 0;

		this.setDimensions(x, y, width, height);
	}

	clear (renderer: Renderer) {
		const gl = renderer.gl;
		const binder = this.binders[renderer.id];

		const activeFrameBuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
		gl.enable(gl.SCISSOR_TEST);
		gl.scissor(this.x, this.y, this.width, this.height);
		if (activeFrameBuffer !== binder) {
			gl.bindFramebuffer(gl.FRAMEBUFFER, binder);
		}

		gl.clearColor(this.clearColor.r, this.clearColor.g, this.clearColor.b, this.clearColor.a);
		// TODO: optimize out depth when unnecessary
		gl.depthMask(true);
		gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
		// gl.clear(gl.COLOR_BUFFER_BIT);

		// if (!logged) {
		// 	logged = true;
		// 	const bufferStatus = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
		// 	console.error('glCheckFramebufferStatus', bufferStatus)
		// 	if (bufferStatus === gl.FRAMEBUFFER_COMPLETE) console.error('gl.FRAMEBUFFER_COMPLETE')
		// 	if (bufferStatus === gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT) console.error('gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT')
		// 	if (bufferStatus === gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT) console.error('gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT')
		// 	if (bufferStatus === gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS) console.error('gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS')
		// 	if (bufferStatus === gl.FRAMEBUFFER_UNSUPPORTED) console.error('gl.FRAMEBUFFER_UNSUPPORTED')
		// }

		if (activeFrameBuffer !== binder) {
			gl.bindFramebuffer(gl.FRAMEBUFFER, activeFrameBuffer);
		}

		gl.disable(gl.SCISSOR_TEST);
	}

	bindFrameBuffer (renderer: Renderer) {
		const gl = renderer.gl;
		const rendererID = renderer.id;

		let binder = this.binders[rendererID];
		if (binder === undefined) {
			const newBinder = gl.createFramebuffer();
			if (newBinder === null) {
				throw new Error('Could not create frame buffer');
			}

			this.binders[rendererID] = binder = newBinder;
		}

		gl.bindFramebuffer(gl.FRAMEBUFFER, binder);
	}

	setDimensions (x: number, y: number, width: number, height: number) {
		this.x = (x < 0) ? 0 : x;
		this.y = (y < 0) ? 0 : y;

		// Dimension of the frame buffer adjusted to pixel ratio
		this.width  = (width < 2) ? 2 : width;
		this.height = (height < 2) ? 2 : height;

		// this.aspectRatio = this.height / this.width;
	}

	// delete () {
	// 	this._gl.deleteFramebuffer(this.binder);
	// }
}
